<template>
  <q-dialog
    ref="dialogRef"
    persistent
    maximized
    class="fit"
    @hide="hideDialog">
    <q-card
      class="q-dialog-plugin column"
      style="width: 100vw; height: 100vh">
      <q-card-section
        v-if="currentInstance"
        class="row items-center q-pb-none">
        <div class="text-h6">{{ currentInstance.title }}</div>
        <q-space />
        <q-btn
          v-close-popup
          :icon="symRoundedClose"
          color="negative"
          flat
          round
          dense />
      </q-card-section>

      <q-card-section class="col fit column q-pa-none">
        <component
          :is="getMainComponent(currentInstance.moduleName)"
          v-if="currentInstance"
          :instance="currentInstance"
          class="col fit column"
          @complete="onComplete" />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { symRoundedClose } from '@quasar/extras/material-symbols-rounded'
import { useDialogPluginComponent } from 'quasar'
import useCrudUtils from 'src/CrudManager/Core/composables/CrudUtils/useCrudUtils'
import { useCrudManagerStore } from 'src/CrudManager/Core/stores/useCrudManagerStore'
import type { CrudInstance } from 'src/CrudManager/Core/types/AdvancedCrudManager'
import { onMounted, ref } from 'vue'

const props = defineProps<{
  instanceId: string
}>()

const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent()

const crudManagerStore = useCrudManagerStore()
const { getInstanceById } = useCrudUtils()

const currentInstance = ref(null as CrudInstance | null)

const getMainComponent = (moduleName: string) => {
  if (!moduleName) return null
  const module = crudManagerStore.getModule(moduleName)
  return module && 'mainComponent' in module ? module.mainComponent : null
}

const getInstance = () => {
  currentInstance.value = getInstanceById(props.instanceId)
}

const hideDialog = () => {
  onDialogHide()
  if (currentInstance.value) {
    crudManagerStore.removeInstance(currentInstance.value, false)
  }
}

const onComplete = () => {
  onDialogOK()
}

onMounted(() => {
  getInstance()
})
</script>
